export function LeftIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M17.5 21L10.5 14L17.5 7" stroke="#18191B" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function RightIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M10.5 7L17.5 14L10.5 21" stroke="#18191B" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export function AddIcon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                opacity="0.5"
                data-figma-bg-blur-radius="50"
                d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
                fill="#CFD0D2"
            />
            <path d="M26 19.916H14M20.0185 13.916V25.916" stroke="#595C61" strokeWidth="1.81827" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <clipPath id="bgblur_0_7109_10820_clip_path" transform="translate(50 50)">
                    <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" />
                </clipPath>
                <clipPath id="bgblur_1_7109_10820_clip_path" transform="translate(45 45)">
                    <path d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function DownIcon(props: any) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                data-figma-bg-blur-radius="33.3333"
                d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
                fill="#DFE0E1"
            />
            <path
                d="M15.6172 17.2796C15.2472 16.9068 14.6475 16.9068 14.2775 17.2796C13.9075 17.6523 13.9075 18.2567 14.2775 18.6295L19.3301 23.7204C19.6968 24.09 20.2903 24.0937 20.6616 23.7286L25.7142 18.7617C26.0887 18.3935 26.0961 17.7892 25.7307 17.4119C25.3653 17.0345 24.7655 17.0271 24.391 17.3952L20.0082 21.7038L15.6172 17.2796Z"
                fill="#595C61"
            />
            <defs>
                <clipPath id="bgblur_0_7614_9923_clip_path" transform="translate(50 50)">
                    <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" />
                </clipPath>
                <clipPath id="bgblur_1_7614_9923_clip_path" transform="translate(28.3333 28.3333)">
                    <path d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" />
                </clipPath>
            </defs>
        </svg>
    );
}
